import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FilterService} from 'src/app/services/filter.service';
import {LineSeriesMetric, SeriesName} from 'src/app/models/graph-series';
import {LineChartServiceBase} from 'src/app/services/line-chart.service.base';

@Injectable({providedIn: 'root'})
export class ReferralsSubmittedSeriesService extends LineChartServiceBase {
  constructor() {
    const http = inject(HttpClient);
    const filterService = inject(FilterService);

    super(
      http,
      filterService,
      [SeriesName.agency],
      LineSeriesMetric.referralsSubmitted
    );
  }
}
